export class Reward {
  constructor(reward) {
      this.id           = reward.id;
      this.point        = reward.point;
      this.content      = reward.content;
      this.created_at   = reward.created_at;
      this.updated_at   = reward.updated_at;
      this.is_active    = reward.is_active;
      this.logic_type   = reward.logic_type;
      this.logic_value  = reward.logic_value;
  }
}
